import React, { useState } from "react";
import Button from "@atlaskit/button";
import { getLJsonStorage, setLJsonStorage, useDevice } from "../../welcome-dashboard/Utils";
import { FEATURE_CUSTOM_REDUX_V3 } from "../../constant";
import { InvitedUserConfirmFlag, _startConference, getBaseConfig } from "../../Utils";
import { useDispatch, useSelector } from "react-redux";
import { setPrejoinScreenUserRoute, setShowDevicePreConnection } from '../../redux/tool-webjam-v3/actions';
import { CURRENT_ROOM_NAME } from "../../../webjam/constant";
import { setPrejoinPageVisibility } from "../../../prejoin/actions.web";
import { updateUserJamStateReq } from "../../welcome-dashboard/Request.d";
import Dialog from "../../../base/ui/components/web/Dialog";
import { ct } from "../../constant-Utils";

export const PrejoinScreenUserRoute = () => {
    const { isMobile } = useDevice();
    const dispatch = useDispatch();
    const { prejoinScreenUserRoute } = useSelector((state) => state[FEATURE_CUSTOM_REDUX_V3]);

    const [isDontShowAgainChecked, setIsDontShowAgainChecked] = useState(false);

    const handleClick = async (withoutJam) => {
        //Jamming Capability =>  1 = Always Ask, 2 = Live Jamming, 3 = No Live Jamming
        if (withoutJam) {
            if (isDontShowAgainChecked) {
                let jammingInfo = getLJsonStorage("auth", "current_room_jamming_capability") || {};
                jammingInfo.status = 3;
                setLJsonStorage("auth", {
                    with_jam: false,
                    current_room_jamming_capability: jammingInfo
                })

                await updateUserJamStateReq({
                    jamming_capability: 3,
                    room_name: CURRENT_ROOM_NAME
                })
            }
            dispatch(setPrejoinScreenUserRoute(InvitedUserConfirmFlag.WITHOUT_DEVICE))
        } else {
            if (isDontShowAgainChecked) {
                let jammingInfo = getLJsonStorage("auth", "current_room_jamming_capability") || {};
                jammingInfo.status = 2;

                setLJsonStorage("auth", {
                    with_jam: true,
                    current_room_jamming_capability: jammingInfo
                })
                await updateUserJamStateReq({
                    jamming_capability: 2,
                    room_name: CURRENT_ROOM_NAME
                })
            }

            dispatch(setPrejoinScreenUserRoute(InvitedUserConfirmFlag.WITH_DEVICE))
            if (getBaseConfig("showPreJoiningInConference")) {
                dispatch(setShowDevicePreConnection(true));
            }
        }
        const hidePreJoinScreen = getBaseConfig("hidePreJoinScreen");
        dispatch(setPrejoinPageVisibility(!hidePreJoinScreen, 4));
    }

    const handleChange = (e) => {
        setIsDontShowAgainChecked(e.target.checked);
    };

    return (
        <>
            {prejoinScreenUserRoute == InvitedUserConfirmFlag.IS_CONFIRMING &&
                <Dialog
                    disableAutoHideOnSubmit={true}
                    disableBackdropClose={true}
                    hideCloseButton={true}
                    cancel={{ hidden: true }}
                    ok={{ hidden: true }}
                    titleKey={ct("Translate.messages.jammingModalTitle")}
                    rtaClassName="jamming-modal-popup"
                    testId="jamming-modal-popup"
                >
                    <>
                        <div className={`mt-2 row`} style={{ justifyContent: 'space-between' }}>
                            <div className="col-md-6 mb-5">
                                <Button id="without-real-time-jamming" onClick={() => handleClick(true)} className="submit-button login-btn-pass join-meeting-pass w-100">
                                    {ct("Translate.messages.withOutRTAJamming")}
                                </Button>
                                <div className={isMobile ? "mt-2" : "mt-5"} style={{ color: '000' }}>
                                    <h4>{ct("Translate.typography.requires")}</h4>
                                    <ul className="require-list mb-2">
                                        <li>{ct("Translate.messages.basicSubscription")}</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-md-6 mb-5">
                                <Button id="with-real-time-jamming" onClick={() => handleClick(false)} className="submit-button login-btn-pass join-meeting-pass mr-2 w-100 ">
                                    {ct("Translate.messages.withRTAJamming")}
                                </Button>
                                <div className={isMobile ? "mt-2" : "mt-5"} style={{ color: '000' }}>
                                    <h4>{ct("Translate.typography.requires")}</h4>
                                    <ul className="require-list mb-2">
                                        <li>{ct("Translate.messages.RTAPowerDevice")}</li>
                                        <li>{ct("Translate.messages.premiumSubscription")}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="jamming-checkbox-container row mb-2 d-flex justify-content-center align-items-center" style={{ color: "#000" }}>
                            <div className="check-btn position-relative" style={{ width: '25px', height: '16px' }}>
                                <input
                                    type="checkbox"
                                    checked={isDontShowAgainChecked}
                                    onChange={(e) => handleChange(e)}
                                />
                                <span className="checkmark"></span>
                            </div>
                            {ct("Translate.messages.doNotShow")}
                        </div>
                    </>
                </Dialog>
            }
        </>
    );
};
